import { RouteConfig } from 'vue-router';

export const notFoundRoute: RouteConfig = {
  path: '*',
  component: () =>
    import(/* webpackChunkName: "PageNotFound" */ '@/views/PageNotFound.vue')
};
